import React from 'react';
import {
  Button,
  DialogTitle,
  Dialog as MaterialDialog,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@material-ui/core';

import { IDialogLocalProps } from './interfaces';

const DialogLocal: React.FC<IDialogLocalProps> = ({
  open = false,
  onClose = () => null,
  title,
  content: Content,
  hasCancelButton = true,
  hasConfirmButton = true,
  confirmCallback = () => null,
  confirmLabel = 'OK',
  cancelCallback = () => null,
  cancelLabel = 'Cancelar',
  isCentralized = false,
}: IDialogLocalProps) => {
  const handleClose = () => {
    if (cancelCallback) {
      cancelCallback();
    }
    onClose();
  };

  const handleConfirm = () => {
    if (confirmCallback) {
      confirmCallback();
    }
    onClose();
  };

  return (
    <MaterialDialog open={open} onClose={handleClose} maxWidth="md">
      <DialogTitle
        id="form-dialog-title"
        style={{ margin: isCentralized ? 'auto' : '' }}
      >
        {title}
      </DialogTitle>
      <DialogContent>
        {typeof Content === 'string' ? (
          <DialogContentText>{Content}</DialogContentText>
        ) : (
          <Content />
        )}
      </DialogContent>
      <DialogActions>
        {hasCancelButton && (
          <Button variant="outlined" onClick={handleClose}>
            {cancelLabel}
          </Button>
        )}
        {hasConfirmButton && (
          <Button
            variant="contained"
            onClick={handleConfirm}
            style={{ margin: isCentralized ? 'auto' : '' }}
          >
            {confirmLabel}
          </Button>
        )}
      </DialogActions>
    </MaterialDialog>
  );
};

export default DialogLocal;
